import { t } from '@lingui/macro'

export type ReasonCode = 'forgotten_clock' | 'technical_issue' | 'recovered_leave' | 'data_entry_error'

export const REASON_CODE_VALUES: ReasonCode[] = ['forgotten_clock', 'technical_issue', 'recovered_leave', 'data_entry_error']

export function getReasonCodeOptions(): Array<{ value: ReasonCode; label: string }> {
  return [
    { value: 'forgotten_clock', label: t`Forgotten clock-in/out` },
    { value: 'technical_issue', label: t`Technical issue` },
    { value: 'recovered_leave', label: t`Recovered leave` },
    { value: 'data_entry_error', label: t`Data entry error` },
  ]
}
